import { DateTime } from "luxon";

export function TimeHourMinute({
  date,
  timeZoneId,
}: {
  date: DateTime;
  timeZoneId?: string;
}) {
  return <>{date.setZone(timeZoneId).toFormat("HH:mm")}</>;
}
